<template>
  <div>
    <div
      class="main-form__info"
      :class="{
        'disabled-inputs': !$guard('write', toCapitilize(type)),
      }"
      v-if="dataUser"
    >
      <div class="main-form__left">
        <!-- <label
          class="empoyee-form__img"
          :style="[
            dataUser.big_image
              ? { backgroundImage: 'url(' + dataUser.big_image + ')' }
              : {},
          ]"
        >
          <img src="/images/master-photo.png" alt />
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            @change="updateImg"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </label>-->
        <div class="main-uploader main-uploader_w210 main-uploader_h216">
          <label
            for="main-uploader__input-file"
            class="main-uploader__file"
            :style="{ backgroundImage: 'url(' + dataUser.big_image + ')' }"
          >
            <img class="main-uploader__icon" src="@/assets/images/addIcon.svg" alt />
            <input
              type="file"
              class="main-uploader__input-file"
              id="main-uploader__input-file"
              @change="updateImg"
              :disabled="!$guard('write', toCapitilize(type))"
            />
          </label>
        </div>
      </div>
      <div class="main-form__right">
        <div class="main-form__box">
          <label
            :data-error="$t('errors.required')"
            :class="{
              'error-input error-input--select': errors.has('service'),
              'success-input': !errors.has('service'),
            }"
          >
            <Select2
              v-model="dataUser.service.id"
              :options="services"
              class="select select2-container_w100"
              v-validate="{ required: true }"
              name="service"
              :settings="selectSetting"
              @change="selectService"
              :disabled="!$guard('write', toCapitilize(type))"
            />
          </label>
        </div>

        <div class="main-form__box">
          <!-- filteredList -->
          <Select2
            v-model="dataUser.office_id"
            :options="filteredList"
            class="select select2-container_w100"
            :settings="selectSettingOffice"
            placeholder="Office"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>

        <div
          class="main-form__half main-form__half_first-pr12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('first_name') }"
        >
          <input
            v-model="dataUser.first_name"
            type="text"
            :placeholder="$t('forms.name')"
            v-validate="{ required: true }"
            name="first_name"
            :disabled="!$guard('write', toCapitilize(type))"
            class="main-form__input"
          />
        </div>
        <div
          class="main-form__half main-form__half_first-pl12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('last_name') }"
        >
          <input
            v-model="dataUser.last_name"
            type="text"
            :placeholder="$t('forms.surname')"
            v-validate="{ required: true }"
            name="last_name"
            :disabled="!$guard('write', toCapitilize(type))"
            class="main-form__input"
          />
        </div>

        <div
          class="main-form__half main-form__half_first-pr12 main-form__half_mb"
          :data-error="$t('errors.phone')"
          :class="{ 'error-input': errors.has('phone') }"
        >
          <vue-tel-input
            autocomplete="off"
            v-model="dataUser.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
            class="main-vue-tel-input"
            :defaultCountry="defaultCountry"
            :disabled="!$guard('write', toCapitilize(type))"
          ></vue-tel-input>
        </div>
        <div
          class="main-form__half main-form__half_first-pl12 main-form__half_mb"
          :data-error="$t('errors.required')"
          :class="{ 'error-input': errors.has('email') }"
        >
          <input
            v-model="dataUser.email"
            type="text"
            placeholder="Email"
            autocomplete="off"
            v-validate="{ required: true }"
            :disabled="!$guard('write', toCapitilize(type))"
            class="main-form__input"
          />
        </div>

        <div class="main-form__box">
          <textarea
            v-model="dataUser.description"
            autocomplete="new-password"
            :placeholder="$t('forms.description')"
            :disabled="!$guard('write', toCapitilize(type))"
            class="main-form__textarea"
          ></textarea>
          <!-- <input
            v-model="dataUser.description"
            type="text"
            autocomplete="new-password"
            :placeholder="$t('forms.description')"
            :disabled="!$guard('write', toCapitilize(type))"
          />-->
        </div>

        <div class="main-form__box">
          <input
            type="text"
            autocomplete="new-password"
            placeholder="Bitte Passwort eingeben"
            v-model="dataUser.password"
            class="main-form__input"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>

        <!-- <div class="empoyee-form__full" v-if="showPartners">
          <Select2
            v-model="dataUser.partner_id"
            :options="mutatedPartners"
            class="select"
            name="partners"
            :settings="{
              placeholder: $t('navigation.partners'),
              allowClear: true,
            }"
            @change="selectPartner"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>-->
        <div class="main-form__box">
          <div class="main-checkbox main-checkbox_flex">
            <input
              class="main-checkbox__input"
              type="checkbox"
              :id="`master-inactive`"
              v-model="dataUser.is_inactive"
              :disabled="!$guard('write', toCapitilize(type))"
            />
            <label :for="`master-inactive`" class="main-checkbox__label">
              <svg
                width="14"
                height="11"
                viewBox="0 0 14 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
                  fill="#9BCD82"
                />
              </svg>
            </label>
            <label class="main-checkbox__label-text" :for="`master-inactive`">
              <!-- <img class="master-badge__icon" :src="item.icon" /> -->
              <span v-text="'Ist der Meister inaktiv?'"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="mpoyee-form__info">
      <div class="main-form__box main-form__box_flex">
        <div class="main-form__box_25 main-form__box_pr24">
          <Select2
            v-model="dataUser.english"
            @change="addLanguage($event, 'en')"
            class="select"
            name="English"
            :settings="{
              placeholder: $t('lang.en'),
              allowClear: false,
            }"
            :options="[
              {
                id: 'doesntKnow',
                text: $t('forms.doesntKnow'),
              },
              {
                id: 'en',
                text: $t('forms.doesKnow'),
              },
            ]"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>

        <div class="main-form__box_25 main-form__box_pr24">
          <Select2
            v-model="dataUser.germany"
            @change="addLanguage($event, 'de')"
            class="select"
            name="Germany"
            :settings="{
              placeholder: $t('lang.de'),
              allowClear: false,
            }"
            :options="[
              {
                id: 'doesntKnow',
                text: $t('forms.doesntKnow'),
              },
              {
                id: 'de',
                text: $t('forms.doesKnow'),
              },
            ]"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>

        <div class="main-form__box_25 main-form__box_pr24">
          <datetime
            class="short-text theme-primary birthday__datepicker"
            v-model="dataUser.birthday"
            input-class="date-input"
            :placeholder="'Date of birthday'"
            format="yyyy-MM-dd"
            type="date"
            :max-datetime="maxDateTime"
            :min-datetime="minDateTime"
            :disabled="!$guard('write', toCapitilize(type))"
          />
        </div>
      </div>

      <div class="main-form__buttons main-form__buttons_center">
        <span
          @click="$emit('cancelAction')"
          class="main-button main-button_cancel mr24"
        >{{ $t("global.close") }}</span>

        <button
          @click="comfirm"
          class="main-button"
          :class="{
            disabled: !isValid,
            disabled_green: !isValid,
          }"
          :disabled="!isValid || !$guard('write', toCapitilize(type))"
        >
          <span v-if="typeAction === 'add'">{{ $t("global.add") }}</span>
          <span v-else>{{ $t("global.edit") }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { checkEmail } from '@/utils/checkEmail'
import moment from 'moment'

export default {
    props: {
        typeAction: {
            required: true,
        },
        dataUser: {
            required: true,
        },
        type: {
            required: true,
        },
        schedule: {
            required: true,
        },
        services: {
            required: true,
        },
        partners: {
            required: true,
        },
        setAvatar: {
            required: true,
        },
        specialistComments: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            spec: 'specialists/getSpecialist',
            filteredList: 'offices/filteredList',
        }),
        isValid() {
            if (this.dataUser.password !== null && this.dataUser.password !== undefined) {
                if (this.dataUser.password.length < 8) {
                    return false
                }
            }

            if (
                (this.dataUser.password === '' || this.dataUser.password === null)
        && this.typeAction === 'add'
            ) {
                return false
            }

            if (this.dataUser.first_name === '' || this.dataUser.first_name === null) {
                return false
            }

            if (this.dataUser.last_name === '' || this.dataUser.last_name === null) {
                return false
            }

            if (this.dataUser.office_id === '' || this.dataUser.office_id === null) {
                return false
            }

            if (!this.isValidPhone) {
                return false
            }

            if (this.dataUser.email === '' || !checkEmail(this.dataUser.email)) {
                return false
            }

            if (this.dataUser.service.id === '' || this.dataUser.service.id === null) {
                return false
            }

            if (this.dataUser.languages) {
                if (this.dataUser.languages.length === 0) {
                    return false
                }
            }

            return !(this.dataUser.birthday === null || this.dataUser.birthday === '')
        },
        maxDateTime() {
            return moment(moment().subtract(18, 'years')).format()
        },
        minDateTime() {
            return moment(moment().subtract(90, 'years')).format()
        },
    },
    data() {
        return {
            selectSetting: {
                placeholder: this.$t('navigation.services'),
            },
            selectSettingOffice: {
                placeholder: 'Office',
            },
            dateFrom: '',
            mutatedPartners: null,
            showPartners: false,
            isValidPhone: false,
            defaultCountry: this.$config.behavior === 'hilfy' ? 'at' : 'de',
        }
    },
    methods: {
        ...mapMutations({
            setAvatarSpecialist: 'specialists/setAvatarSpecialist',
            setSpecialistImageFormData: 'specialists/setSpecialistImageFormData',
        }),
        ...mapActions({
            updateSpecialistAvatar: 'specialists/updateSpecialistAvatar',
        }),
        close() {
            this.$emit('cancelAction')
        },
        updateImg(event) {
            const files = event.target.files[0]
            const formData = new FormData()

            if (files) {
                const reader = new FileReader()
                reader.readAsDataURL(files)
                reader.onload = () => {
                    this.dataUser.big_image = reader.result
                }
            }

            formData.append('image', files)
            this.setSpecialistImageFormData(formData)

            if (this.typeAction === 'add') {
                return
            }

            this.updateSpecialistAvatar({
                type: this.type,
                id: this.dataUser.id,
                data: formData,
            })
        },
        selectService() {
            this.errors.items = this.errors.items.filter((e) => e.field !== 'service')
        },
        selectPartner($e) {
            this.dataUser.partner_id = $e
        },
        comfirm() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.dataUser.phone = this.dataUser.phone.replace(/\s+/g, '')

                    if (this.dataUser.partner_id === 'all') {
                        this.dataUser.partner_id = null
                    }

                    if (this.dataUser.partner !== null) {
                        delete this.dataUser.partner
                    }

                    this.$emit('okAction')
                }
            })
        },
        toCapitilize(v) {
            const word = v.split('')
            word[0] = word[0].toUpperCase()
            return word.join('')
        },
        addLanguage(value, lang) {
            const matchIndex = this.dataUser.languages.lastIndexOf(lang)

            if (value === 'doesntKnow' && matchIndex !== -1) {
                this.dataUser.languages.splice(matchIndex, 1)
            } else if (value !== 'doesntKnow' && matchIndex === -1) {
                this.dataUser.languages.push(value)
            }
        },
        fetchOrder(id) {
            this.$emit('fetchOrder', id)
        },
        checkValue(v) {
            this.isValidPhone = v.valid && v.type === 'mobile'
        },
    },
    beforeMount() {
        const birthday = this.dataUser.birthday || moment('1970-01-02')
        this.dataUser.birthday = moment(birthday)
            .add('days', 1)
            .format('YYYY-MM-DD')

        if (this.dataUser.languages === undefined) {
            return
        }

        if (this.dataUser.languages.indexOf('en') !== -1) {
            this.dataUser.english = 'en'
        }

        if (this.dataUser.languages.indexOf('de') !== -1) {
            this.dataUser.germany = 'de'
        }

        this.mutatedPartners = this.partners.reduce((accum, item) => {
            const data = {
                id: item.id,
                text: item.name,
            }
            accum.push(data)
            return accum
        }, [])

        if (this.mutatedPartners[0] === null) {
            return
        }

        if (this.mutatedPartners[0].id === 'all') {
            return
        }

        this.mutatedPartners.unshift({
            id: 'all',
            text: this.$config.behavior === 'hilfy' ? 'Hilfy' : 'Profy',
        })

        this.showPartners = true

        if (this.dataUser.partner_id === null) {
            this.dataUser.partner_id = 'all'
        }
    },
}
</script>
